import settings from './settings';
import ssmlTags from './ssmlTags';
import bookpart from './bookparts/bookpart';

export function initEditorStore(store) {
    store.registerModule('bookpart', bookpart);
    store.registerModule('settings', settings);
    store.registerModule('ssmlTags', ssmlTags);
}
